<template>
  <div>
    <div class="util-date-filter" @click="filterShow = true">
      <img src="@/assets/img/util-date.svg" />
      <span
        >{{ dayjs(dates?.start).format("D MMM YYYY") }} -
        {{ dayjs(dates?.end).format("D MMM YYYY") }}</span
      >
      <img src="@/assets/img/util-date-down.svg" />
    </div>
    <div class="util-filter-modal" :class="filterShow ? '' : 'hides'">
      <div class="util-bd" @click="filterShow = false"></div>
      <div class="util-pn">
        <span></span>
        <img
          src="@/assets/img/filter-close.svg"
          class="util-close"
          @click="filterShow = false"
        />
        <fieldset>
          <span>Date Start</span>
          <div>
            <img src="@/assets/img/filter-date.svg" />
            <input
              type="date"
              onclick="this.showPicker()"
              v-model="start_date"
            />
          </div>
        </fieldset>
        <fieldset>
          <span>Date End</span>
          <div>
            <img src="@/assets/img/filter-date.svg" />
            <input type="date" onclick="this.showPicker()" v-model="end_date" />
          </div>
        </fieldset>
        <span></span>
        <button @click="apply">Apply</button>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import dayjs from "dayjs";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { Component, Watch } from "vue-property-decorator";
@Component({
    components: {
    },
})
export default class UtilitiesDate extends Vue {
    @Prop() dates
    filterShow = false
    start_date = dayjs().subtract(7, "days").format("YYYY-MM-DD")
    end_date = dayjs().format("YYYY-MM-DD")
    dayjs = dayjs
    @Watch("filterShow")
    onChangefilterShowState() {
      if(this.filterShow){
        this.start_date = this.dates.start
        this.end_date = this.dates.end
      }
    }
    apply(){
        this.filterShow = false
        this.$emit("apply", {start: this.start_date, end: this.end_date})
    }
}
</script>
